module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/profile_page/society-87d82703a447346fa203bbea470e2b89.png";